module.exports = __webpack_public_path__ + "assets/img/block-left-hover-f1450a1f.png";